import { css } from '@linaria/core';
import { theming, breakpoints } from 'styles/utils';
import { NAVBAR_HEIGHT } from 'styles/constants';
export const container = "odules__PageNotFound__PageNotFound_styles_ts-container-c1taoyc4";
export const pageTitle = "odules__PageNotFound__PageNotFound_styles_ts-pageTitle-p1k0nmfg";
export const subtitle = "odules__PageNotFound__PageNotFound_styles_ts-subtitle-s12lszt8";
export const btn = "odules__PageNotFound__PageNotFound_styles_ts-btn-blwhh48";
export const img = "odules__PageNotFound__PageNotFound_styles_ts-img-is98tql";

require("./PageNotFound.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PageNotFound.styles.ts");